/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  objectIds,
  systemTicketNumberPluginId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGINS_INPUT,
  DEFAULT,
} = require('../../scopes');

module.exports = {
  createCustomerSystemTicketNumberPlugin: {
    properties: {
      body: {
        properties: {
          systemTicketNumberPluginId,
        },
        required: ['systemTicketNumberPluginId'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
        },
        required: ['customerId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  deleteCustomerSystemTicketNumberPlugins: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
        },
        required: ['customerId'],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerSystemTicketNumberPlugins: {
    properties: {
      params: {
        properties: {
          customerId,
        },
        required: ['customerId'],
        type: 'object',
      },
      query: createQueryComponent([
        CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGINS_INPUT,
        DEFAULT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
